import React, { useCallback, useEffect, useState } from 'react';
import {
  ButtonIcon,
  Col,
  Icon,
  Input,
  Row,
  Text,
} from '@cubeyou-team/hx-react-components';
import { connect, useSelector } from 'react-redux';
import {
  StyledQueryEntityActions,
  StyledQueryEntityContent,
  StyledQueryEntityDrag,
} from './StyledQueryEntity';
import { QueryRow } from '../index';
import translations from '../../../../lang';
import {
  deleteEntityRequest,
  deleteConversationQueryRequest,
  updateConversationQueryRequest,
} from '../../../../actions';

const ConversationEntityContent = ({
  queryEntity,
  conversationQuery,
  parentGroupId,
  index,
  onEntityDragToggle,
  canDeleteRow = true,
  deleteEntityRequest,
  updateConversationQueryRequest,
  deleteConversationQueryRequest,
}) => {
  const selectedTargetId = useSelector(
    (state) => state.queryBuilder.target_selected
  );
  const [isEditing, SetIsEditing] = useState(false);
  const [isDragging, SetIsDragging] = useState(false);

  const [queryText, setQueryText] = useState('');
  const handleQueryTextKeyDown = useCallback(
    (event) => {
      if (event.keyCode === 13) {
        if (!queryText) {
          deleteEntityRequest(selectedTargetId, parentGroupId, index);
          deleteConversationQueryRequest(
            selectedTargetId,
            parentGroupId,
            queryEntity.id
          );
        } else {
          updateConversationQueryRequest(
            selectedTargetId,
            parentGroupId,
            queryText,
            queryEntity.id,
            index
          );

          if (queryText !== undefined) {
            SetIsEditing(false);
          }
        }
      }
    },
    [
      selectedTargetId,
      parentGroupId,
      queryEntity,
      queryText,
      updateConversationQueryRequest,
      index,
      deleteEntityRequest,
      deleteConversationQueryRequest,
    ]
  );

  useEffect(() => {
    if (conversationQuery !== undefined) {
      SetIsEditing(false);
    }
  }, [conversationQuery]);

  const handleQueryTextChange = useCallback((queryText) => {
    setQueryText(queryText);
  }, []);

  const handleQueryTextBlur = useCallback(
    (event) => {
      const text = event.target.value;
      if (!text) {
        if (!canDeleteRow) {
          SetIsEditing(false);
          return;
        }
        deleteEntityRequest(selectedTargetId, parentGroupId, index);
        deleteConversationQueryRequest(
          selectedTargetId,
          parentGroupId,
          queryEntity.id
        );
      } else {
        updateConversationQueryRequest(
          selectedTargetId,
          parentGroupId,
          text,
          queryEntity.id,
          index
        );
      }
      SetIsEditing(false);
    },
    [
      selectedTargetId,
      parentGroupId,
      index,
      queryEntity,
      canDeleteRow,
      deleteEntityRequest,
      deleteConversationQueryRequest,
      updateConversationQueryRequest,
    ]
  );

  return (
    <React.Fragment>
      <QueryRow
        draggable={!isEditing}
        isDragging={isDragging}
        onDragStart={(e) => {
          SetIsDragging(true);
          onEntityDragToggle(true);
          e.dataTransfer.setData('itemId', e.target.dataset.itemId);
          e.dataTransfer.setData('entityIndex', index);
          e.dataTransfer.setData('parentId', e.target.dataset.parentId);
        }}
        onDragEnd={(e) => {
          SetIsDragging(false);
          onEntityDragToggle(false);
        }}
        data-item-id={queryEntity.id}
        data-parent-id={parentGroupId}
      >
        <StyledQueryEntityDrag isDragging={isDragging}>
          <Icon icon="drag" size="small" variant="dark_lighter" />
        </StyledQueryEntityDrag>
        <StyledQueryEntityContent>
          {isEditing || !conversationQuery ? (
            <Input
              placeholder={
                translations['en-US'].QUERY_BUILDER.conversationQueryText
              }
              type="text"
              name="queryText"
              size="thin"
              value={queryText}
              onChange={(e) => handleQueryTextChange(e.target.value)}
              onKeyDown={(e) => handleQueryTextKeyDown(e)}
              onBlur={(e) => handleQueryTextBlur(e)}
              autoFocus
            />
          ) : (
            <Row valign="middle">
              <Col span="auto">
                <Text size="small">{conversationQuery}</Text>
              </Col>
            </Row>
          )}
        </StyledQueryEntityContent>
        <StyledQueryEntityActions>
          <Row>
            {!isEditing && (
              <Col span="auto">
                <ButtonIcon
                  icon="edit"
                  size="small"
                  type="button"
                  variant="dark_lighter"
                  onClick={(e) => {
                    e.preventDefault();
                    SetIsEditing(true);

                    if (conversationQuery) {
                      setQueryText(conversationQuery);
                    }
                    e.stopPropagation();
                  }}
                />
              </Col>
            )}

            {canDeleteRow && (
              <Col span="auto">
                <ButtonIcon
                  icon="delete"
                  size="small"
                  type="button"
                  variant="dark_lighter"
                  onClick={(e) => {
                    e.preventDefault();
                    deleteEntityRequest(selectedTargetId, parentGroupId, index);
                    deleteConversationQueryRequest(
                      selectedTargetId,
                      parentGroupId,
                      queryEntity.id
                    );
                    e.stopPropagation();
                  }}
                />
              </Col>
            )}
          </Row>
        </StyledQueryEntityActions>
      </QueryRow>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  queryBuilder: state.queryBuilder,
});

const mapDispatchToProps = {
  deleteEntityRequest,
  updateConversationQueryRequest,
  deleteConversationQueryRequest,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConversationEntityContent);
